const styles = theme => ({
  search: {
    position: 'relative',
    // display: 'inline-block',
    width: '100%',
  },
  input: {
    width: '100%',
    height: 40,
    margin: 0,
    padding: 0,
    paddingRight: 46,
    paddingLeft: theme.fontSize,
    border: `1px solid ${theme.qlikGreen}`,
    boxSizing: 'border-box',
  },
  iconContainer: {
    position: 'absolute',
    top: 1,
    right: 0,
    width: 40,
    height: 40,
    // background: theme.qlikGreen,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  searchIcon: {
    color: theme.qlikGreen,
    // border: '1px solid #fff',
    borderRadius: '100%',
    fontSize: theme.fontSize * 1.5,
    padding: theme.fontSize / 2,
  },
  closeIcon: {
    position: 'absolute',
    fontSize: theme.fontSize,
    left: 175,
    top: theme.fontSize,
    color: '#666',
    cursor: 'pointer',
  },
});

export default styles;
